import { createContext, useContext } from 'react'

import { AnyRouter, RouteApi } from '@tanstack/react-router'
import { ClientPortalUsersActivityReportResponse } from '~bank-reports/types/ClientPortalUsersActivityReport'

type ClientPortalUsersActivityReportContextValue = {
  data: ClientPortalUsersActivityReportResponse
  isFetching: boolean
  routeApi: RouteApi<'/_app/reports/client', AnyRouter>
}

export const ClientPortalUsersActivityReportContext = createContext<ClientPortalUsersActivityReportContextValue | null>(
  null
)

export const useClientPortalReportContext = () => {
  const context = useContext(ClientPortalUsersActivityReportContext)
  if (!context) {
    throw new Error(
      'useClientPortalUsersActivityReportContext must be used within a ClientPortalUsersActivityReportContext.Provider'
    )
  }
  return context
}
